export const cells = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth'] as const
export const statistics = ['third', 'fourth', 'fifth'] as const
export const table = {
  head: ['first', 'second', 'third', 'fourth'],
} as const

export const colors = [
  '#3D70FF',
  '#1B46BF',
  '#23366A',
  '#21252D',
  '#136F5F',
  '#21A48D',
  '#3DD1AE',
  '#80E6CD',
  '#DDE4EA',
  '#D1E9FF',
  '#9BC3FF',
]
